import { Link } from 'react-router-dom';

type Props = {
  id: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  t: (key: string) => string;
  required?: boolean;
};

export function AuthTermsCheckbox({ id, checked, onChange, t, required = false }: Props) {
  return (
    <label className="login-check registration-terms" htmlFor={id}>
      <input
        id={id}
        type="checkbox"
        name="agreedToTerms"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className="login-check__input"
        required={required}
      />
      <span className="login-check__box" aria-hidden />
      <span className="registration-terms__text">
        <span className="registration-terms__line">
          {t('registration.termsAgreement')}{' '}
          <Link to="/terms" className="registration-terms__link">
            {t('registration.termsOfService')}
          </Link>{' '}
          {t('registration.and')}
        </span>
        <span className="registration-terms__line">
          <Link to="/privacy" className="registration-terms__link">
            {t('registration.privacyPolicy')}
          </Link>
        </span>
      </span>
    </label>
  );
}
